import FeatureCardGridView from "@/components/feature/FeatureCardGridView";
import { useAreaName } from "@/hooks/useAreaName";
import type { Feature, LayoutContext } from "@/lib/models";
import { FeatureService } from "@/services/FeatureService";
import { FeatureTypeService, type FeatureType } from "@/services/FeatureTypeService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

interface AreaFeatureCardGridViewProps {
  featureTypeSubType: string;
}

const AreaFeatureCardGridView: React.FC<AreaFeatureCardGridViewProps> = ({ featureTypeSubType }) => {
  const params = useParams();
  const { areaName } = useAreaName(params.areaId!);
  const { setPageName } = useOutletContext<LayoutContext>();
  const [featureList, setFeatureList] = useState<Feature[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setPageName(`Area: ${areaName} ${featureTypeSubType} Features`);
  }, [areaName, setPageName, featureTypeSubType]);

  useEffect(() => {
    const fetchFeatures = async () => {
      if (!params.areaId) {
        return;
      } 

      try {
        const [features, featureTypes] = await Promise.all([
          FeatureService.getByAreaId(params.areaId!),
          FeatureTypeService.getBySiteId(params.siteId!)
        ]);
        const record: Record<string, FeatureType> = featureTypes.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {} as Record<string, FeatureType>);
        
        setFeatureList(
          features
            .filter((feature) => {
              const featureType = record[feature.codeId!];
              return featureType.subType === featureTypeSubType;
            }));
      }
      finally {
        setIsLoading(false);
      }

    };
    fetchFeatures();
  }, [params.areaId, params.siteId, featureTypeSubType]);

  return (
    <div className="container mx-auto p-4">
      <FeatureCardGridView pageTitle={`Area: ${areaName}`} featureList={featureList} isLoading={isLoading} />
    </div>
  );
};

export default AreaFeatureCardGridView;
